import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { DateUtils } from '@macs-frontend/web-macs/shared/utils/date';

@Pipe({ name: 'calculateAge' })
export class CalculateAgePipe implements PipeTransform {
  @memoize()
  public transform(value: string): number {
    return DateUtils.calculateAge(value);
  }
}
